$(document).ready(function () {
  let p = $('body').attr('p');
  let a = $('body').attr('a');
  const locationId = $('body').attr('event_id');

  if (p === 'inventory') {
    $(document).on('submit', '#inventory-filtered-form', function (e) {
      e.preventDefault();
      let searchString = $('#search_string').val();
      const type = $('#event_ticket_category_table').attr('data-current-type');
      const formData = new FormData(e.target);
      formData.append('type', type);
      formData.append('search_string', searchString);
      formData.append('product_type', 0);
      $.ajax({
        type: 'POST',
        url: '/ajax/inventory/search',
        data: formData,
        enctype: 'multipart/form-data',
        async: true,
        cache: false,
        processData: false,
        contentType: false,
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            $('#product-list').empty();
            $('#product-list').append(data.html);
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    });
  }
});
